import * as React from 'react';
import {Helmet} from 'react-helmet';
import {Route, RouteChildrenProps, Switch} from 'react-router-dom';
// async components
import {AsyncDocumentEditComponent, AsyncDocumentListComponent} from '../components/AsyncComponent/AsyncComponent';
import {documentTypeIdRegexp} from '../constants';
import {useTranslation} from "react-i18next";
import {config} from "../config";

const Documents: React.FunctionComponent<RouteChildrenProps> = ({match}) => {
    const {t: translate} = useTranslation();
    return (
        <div className="content-wrapper">
            <Helmet>
                <title>{`${config.app.name} - ${translate('documents.name')}`}</title>
                <meta name="description" content="Documents"/>
            </Helmet>
            <Switch>
                <Route
                    exact
                    path={`${match?.url}/:documentType(${documentTypeIdRegexp})`}
                    component={AsyncDocumentListComponent}
                />
                <Route
                    exact
                    path={`${match?.url}/:id([0-9]+)`}
                    component={AsyncDocumentEditComponent}
                />
                <Route
                    exact
                    path={`${match?.url}`}
                    component={AsyncDocumentListComponent}
                />
            </Switch>
        </div>
    );
};

export default Documents;
